/** 履约待办中心 API（T5） */

import request from './request';

/** 待办条目（对齐后端 TodoItemVO） */
export interface TodoItem {
  orderId: string;
  /** 任务 ID（改派等操作入参） */
  taskId: string;
  orderNo?: string;
  nodeCode: string;
  nodeName?: string;
  substepCode?: string;
  substepName?: string;
  taskStatus: string;
  dueAt?: string;
  overdueFlag?: boolean;
  waitedHours?: number;
  quickAction?: string;
}

/** 流转日志条目（对齐后端 NodeTransitionLog） */
export interface TransitionLogItem {
  id: string;
  orderId: string;
  seq: number;
  action: string;
  fromNodeCode?: string;
  toNodeCode?: string;
  fromNodeName?: string;
  toNodeName?: string;
  blockedReason?: string;
  operatorId?: string;
  operatorName?: string;
  operatorSource?: string;
  ipAddress?: string;
  remark?: string;
  requestId?: string;
  createdAt?: string;
}

/** 待办三 Tab 查询 */
export function getTodo(tab: 'TO_DO' | 'FOLLOWING' | 'DONE' = 'TO_DO') {
  return request<TodoItem[]>({ url: '/fulfillment/todo', method: 'GET', params: { tab } });
}

/** 待办红点计数（仅 TO_DO） */
export function getTodoCount() {
  return request<number>({ url: '/fulfillment/todo/count', method: 'GET' });
}

/** 任务改派 */
export function reassignTask(taskId: string, roleKey: string) {
  return request<boolean>({ url: `/fulfillment/task/${taskId}/reassign`, method: 'POST', data: { roleKey } });
}

/** 订单流转轨迹（节点名取审计快照列） */
export function getTransitionLogs(orderId: string) {
  return request<TransitionLogItem[]>({ url: `/order/${orderId}/transition-logs`, method: 'GET' });
}

// ==================== 流程模板维护（T4 补全） ====================

/** 流程模板（对齐后端 FulfillmentTemplate） */
export interface FulfillmentTemplateItem {
  id: string;
  code: string;
  name: string;
  tradeTerms?: string;
  category?: string;
  isDefault?: boolean;
  isActive?: boolean;
  version?: number;
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
}

/** 模板节点行（对齐后端 FulfillmentTemplateNode） */
export interface FulfillmentTemplateNodeItem {
  id?: string;
  templateId?: string;
  nodeCode: string;
  nodeSeq?: number;
  taskPolicy: 'TASK' | 'OBSERVE';
  isActive?: boolean;
}

/** 模板 + 节点行联合（对齐后端 TemplateDetail record） */
export interface FulfillmentTemplateDetail {
  template: FulfillmentTemplateItem;
  nodes: FulfillmentTemplateNodeItem[];
}

/** 流程模板列表 */
export function listFulfillmentTemplates() {
  return request<FulfillmentTemplateItem[]>({ url: '/fulfillment/template/list', method: 'GET' });
}

/** 流程模板详情（含节点行） */
export function getFulfillmentTemplate(id: string) {
  return request<FulfillmentTemplateDetail>({ url: `/fulfillment/template/${id}`, method: 'GET' });
}

/** 新建流程模板 */
export function createFulfillmentTemplate(detail: FulfillmentTemplateDetail) {
  return request<FulfillmentTemplateItem>({ url: '/fulfillment/template', method: 'POST', data: detail });
}

/** 更新流程模板（节点行整组替换） */
export function updateFulfillmentTemplate(id: string, detail: FulfillmentTemplateDetail) {
  return request<boolean>({ url: `/fulfillment/template/${id}`, method: 'PUT', data: detail });
}

/** 删除流程模板（默认模板/被快照引用禁止删） */
export function deleteFulfillmentTemplate(id: string) {
  return request<boolean>({ url: `/fulfillment/template/${id}`, method: 'DELETE' });
}

export const fulfillmentApi = {
  getTodo,
  getTodoCount,
  reassignTask,
  getTransitionLogs,
  listFulfillmentTemplates,
  getFulfillmentTemplate,
  createFulfillmentTemplate,
  updateFulfillmentTemplate,
  deleteFulfillmentTemplate,
};
